import { useAtomValue } from "jotai";
import { visitorStateAtom } from "./state";
import { useVisitorId } from "./useVisitorId";
import { useInitUserTracking } from "../hooks/useInitUserTracking";
import { useParams } from "react-router-dom";
import { useMemo } from "react";
import { admissionAttemptsAtom } from "./waiting-room/admission/state";

export function useInitVisitorUserTracking() {
  const visitorId = useVisitorId();
  const visitorState = useAtomValue(visitorStateAtom);
  const { providerShortId } = useParams();
  const admissionAttempts = useAtomValue(admissionAttemptsAtom);
  const joinAttempts = useAtomValue(admissionAttemptsAtom);

  const additionalVars = useMemo(
    () => ({ providerShortId, visitorState, admissionAttempts, joinAttempts }),
    [admissionAttempts, joinAttempts, providerShortId, visitorState],
  );

  useInitUserTracking(visitorId, additionalVars);
}
